import FilterListIcon from '@mui/icons-material/FilterList';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { IconButton, Toolbar } from '@mui/material';
import React from 'react';
import BotaoAdicionar from './BotaoAdicionar';
import LegacyGrid from '../LegacyGrid';

type Props = {
  setColumnsAnchor: (anchor: HTMLButtonElement | null) => void;
  setFilterAnchor: (anchor: HTMLButtonElement | null) => void;
  showFilters: boolean;
  hide?: boolean;
  adicionar?: () => void;
};

const EdTableInfo: React.FC<Props> = (props) => {
  const { setColumnsAnchor, setFilterAnchor, showFilters, adicionar, hide } = props;

  if (hide) {
    return null;
  }

  return (
    <Toolbar style={{ padding: '4px 5px 4px 5px', minHeight: 0 }}>
      <LegacyGrid container>
        <LegacyGrid item xs={8} md={6} style={{ display: 'flex', alignItems: 'center' }}>
          {/* {titulo && (
              <Titulo2 style={{ margin: 0, width: '100%' }}>{titulo}</Titulo2>
            )} */}
        </LegacyGrid>

        <LegacyGrid
          item
          xs={4}
          md={6}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end'
          }}
        >
          <IconButton size={'small'} onClick={(event) => setColumnsAnchor(event.currentTarget)}>
            <ViewColumnIcon />
          </IconButton>
          {showFilters && (
            <IconButton size={'small'} onClick={(event) => setFilterAnchor(event.currentTarget)}>
              <FilterListIcon />
            </IconButton>
          )}
          <BotaoAdicionar adicionar={adicionar} />
        </LegacyGrid>

        {/* <LegacyGrid item xs={12}>
            {chips &&
              chips.map((chip, i) => {
                if (chip.value && chip.defaultValue !== chip.value) {
                  return (
                    <Chip
                      key={'chip' + i}
                      label={`${chip.label}: ${
                        chip.render ? chip.render(chip.value) : chip.value
                      }`}
                      onDelete={chip.onDelete}
                      style={{
                        marginRight: 5,
                        marginBottom: 5,
                        marginTop: 5
                      }}
                    />
                  );
                }
                return null;
              })}
          </LegacyGrid> */}
      </LegacyGrid>
    </Toolbar>
  );
};

export default EdTableInfo;
